import {createContext} from "react";

const UserEmailContext = createContext(null);

export default UserEmailContext;